import React, { memo } from "react";

import { Switch as AntdSwitch } from "antd";
import styles from "./Switch.module.scss";
import { SwitchProps as AntdSwitchProps } from "antd/lib/switch";
import { CenteredSpan } from "app/components/Common/CenteredSpan";

export type SwitchProps = AntdSwitchProps & {
  label?: React.ReactNode;
};

export const Switch = memo(function (props: SwitchProps): React.ReactElement {
  const label = props.label ?? props.title;

  return (
    <div className={styles.switch}>
      <AntdSwitch {...props} />
      {label && (
        <p style={{ margin: 0, lineHeight: 0.9 }}>
          <CenteredSpan>{label}</CenteredSpan>
        </p>
      )}
    </div>
  );
});
